/**
 * Export des pipes
 */
export * from './codeDesignation.pipe'
export * from './codeDesignation.pipeMock.spec'
export * from './translate.pipeMock.spec'
export * from './designation.pipe'
export * from './designation.pipeMock.spec'
export * from './photoGed.pipeMock.spec'
export * from './photoGed.pipe'
export * from './safe.pipe'
export * from './formatter-dlcs-sur-une-seule-ligne.pipe'
export * from './formatter-numeros-lots-fournisseurs.pipe'
export * from './formatter-premier-numero-lot-fournisseur.pipe'
export * from './formatter-premiere-dlcs-fournisseurs.pipe'
export * from './premiere-lettre-majuscule.pipe'
export * from './premiere-lettre-majuscule.pipeMock.spec'
export * from './prix/prix.pipe'
export * from './prix/prix.pipeMock.spec'
export * from './order-by.pipe'
export * from './order-by.pipeMock.spec'
export * from './order-by-date.pipe'
export * from './codeDesignationCohabitation.pipe'
export * from './codeDesignationCohabitation.pipeMock.spec'
export * from './option-vide.pipe'
export * from './option-vide.pipeMock.spec'
export * from './toutes-lettres-majuscule.pipe'
export * from './toutes-lettres-majuscule.pipeMock.spec'
export * from './nomPrenom.pipe'
export * from './nomPrenom.pipeMock.spec'
export * from './arrondi-plus-proche.pipe'
export * from './arrondi-plus-proche.pipeMock.spec'
export * from './code-client-designation.pipe'
